var _path, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTabsIcon7(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 12.5C15.8645 12.5 12.5 15.8645 12.5 20V23.1073C12.5 23.8752 13.1727 24.5 14 24.5H14.75C14.9489 24.5 15.1397 24.421 15.2803 24.2803C15.421 24.1397 15.5 23.9489 15.5 23.75V19.8928C15.5 19.6938 15.421 19.5031 15.2803 19.3624C15.1397 19.2218 14.9489 19.1428 14.75 19.1428H14.069C14.486 16.2403 16.9835 14 20 14C23.0165 14 25.514 16.2403 25.931 19.1428H25.25C25.0511 19.1428 24.8603 19.2218 24.7197 19.3624C24.579 19.5031 24.5 19.6938 24.5 19.8928V24.5C24.5 25.3273 23.8273 26 23 26H21.5V25.25H18.5V27.5H23C24.6545 27.5 26 26.1545 26 24.5C26.8273 24.5 27.5 23.8752 27.5 23.1073V20C27.5 15.8645 24.1355 12.5 20 12.5Z",
    fill: "#FF3636"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.05,
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#FE0000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabsIcon7);
export default __webpack_public_path__ + "static/media/tabs-icon7.5f5a9d24f3cd4461f9abcd68e0d2fe24.svg";
export { ForwardRef as ReactComponent };